import { render, staticRenderFns } from "./UserSettingsPage.vue?vue&type=template&id=3a11ca6c&"
import script from "./UserSettingsPage.vue?vue&type=script&lang=js&"
export * from "./UserSettingsPage.vue?vue&type=script&lang=js&"
import style0 from "./UserSettingsPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports